import type { SVGProps } from 'react';

import type { FileIconProps } from './FileIcon';

export const CertifiedBadge = ({
  size = 28,
  ...props
}: SVGProps<SVGSVGElement> & FileIconProps) => (
  <svg
    width={size * 0.5}
    height={size}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='m8.895 14.083.454-.89-.454.89a2.87 2.87 0 0 0 4.115-1.981.87.87 0 0 1 .492-.618 2.87 2.87 0 0 0 1.017-4.453.87.87 0 0 1-.176-.77 2.87 2.87 0 0 0-2.848-3.57.87.87 0 0 1-.711-.343l-.796.606.796-.606a2.87 2.87 0 0 0-4.568 0 .87.87 0 0 1-.711.342 2.87 2.87 0 0 0-2.848 3.571.87.87 0 0 1-.176.77 2.87 2.87 0 0 0 1.016 4.453.87.87 0 0 1 .493.618 2.87 2.87 0 0 0 4.115 1.981.87.87 0 0 1 .79 0Z'
      fill='#F9DDB3'
      stroke='#fff'
      strokeWidth={2}
    />
    <path d='M6.5 14V9h4v5l-2-1-2 1Z' fill='#965808' />
    <g filter='url(#aa)'>
      <circle cx={8.5} cy={8} r={3} fill='#EFB100' />
    </g>
    <defs>
      <filter
        id='aa'
        x={2.5}
        y={4}
        width={12}
        height={12}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feMorphology radius={1} in='SourceAlpha' result='effect1_dropShadow_3029_10081' />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={2} />
        <feColorMatrix values='0 0 0 0 0.204167 0 0 0 0 0.132708 0 0 0 0 0.0255208 0 0 0 0.25 0' />
        <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_3029_10081' />
        <feBlend in='SourceGraphic' in2='effect1_dropShadow_3029_10081' result='shape' />
      </filter>
    </defs>
  </svg>
);
